import {valueOf} from 'ui/keyboard';
import {useUIStore} from 'store/UI';
import {useKeyboard} from 'store/UserInput';

export function useKeyboardInput(): number {
  const keyboard = useKeyboard();
  return valueOf(keyboard);
}

export function useMainScreenKeyboardInput(): number {
  const {settingsVisible} = useUIStore();
  const keyboardInput = useKeyboardInput();
  return settingsVisible ? 0 : keyboardInput;
}
